export default `
	mutation deleteDoctor($docId:ID!){
			deleteDoctor(docId:$docId){
					docId
			}
		}
	`